import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { WPQTInput } from "../../../common/Input/Input";
import { WPQTTextarea } from "../../../common/TextArea/TextArea";
import { WPQTModalField, WPQTModalFieldSet, WPQTModalFooter, } from "../../WPQTModal";
const PipelineModalContent = forwardRef(({ addPipeline, modalSaving }, ref) => {
    const [pipelineName, setPipelineName] = useState("");
    const [pipelineDescription, setPipelineDescription] = useState("");
    const savePipeline = () => {
        addPipeline(pipelineName, pipelineDescription);
    };
    const clearContent = () => {
        setPipelineName("");
        setPipelineDescription("");
    };
    useImperativeHandle(ref, () => ({
        clearContent,
    }));
    return (_jsxs(_Fragment, { children: [_jsxs(WPQTModalFieldSet, { children: [_jsx(WPQTModalField, { label: __("Name", "quicktasker"), children: _jsx(WPQTInput, { isAutoFocus: true, value: pipelineName, onChange: (newValue) => setPipelineName(newValue) }) }), _jsx(WPQTModalField, { label: __("Description", "quicktasker"), children: _jsx(WPQTTextarea, { rowsCount: 3, value: pipelineDescription, onChange: (newValue) => setPipelineDescription(newValue) }) })] }), _jsx(WPQTModalFooter, { onSave: savePipeline, loading: modalSaving, saveBtnText: __("Add board", "quicktasker") })] }));
});
export { PipelineModalContent };
